<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="pt-[3px] flex items-center">
    <select id="time" class="border rounded-lg border-gray-300 text-xs w-[90px]" @change="update($event)">
      <option v-for="(time, index) in getTime()" :selected="time == value" :key="index" >{{time}}</option>
    </select>
  </div>
</template>

<script>

export default {
    name: "DropDownTime",
    props: {
        value: [String, Object, Boolean, Number],
    },
    data() {
        return {
          timeSelected: '',
          selected: '',
        };
    },
    methods: {
        
        update(event){
          this.$emit('update:modelValue', event.target.value);
        }, 
        
        getTime(){
          // horas entre 00:00 e 23:45 com intervalos de 5 minutos
          let time = [];
          for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 12; j++) {
              let hour = i < 10 ? "0" + i : i;
              let minute = j * 5;
              let minuteString = minute < 10 ? "0" + minute : minute;
              time.push(hour + ":" + minuteString);
            }
          }
          return time;
        }
    },
    components: {
    },
    created() {
      this.$emit('update:modelValue', this.value);
    },

};
</script>